import Vue from 'vue'
import VueRouter from 'vue-router'


// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
// const Home = () => import('@/views/Home')
const Home = () => import('@/views/HomePage.vue')
const AddEmail = () => import('@/views/AddEmail.vue')
const About = () => import('@/views/About.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const Profile = () => import('@/views/Profile.vue')
const ProfileEditPage = () => import('@/views/ProfileEdit.vue')
const MemberAdd = () => import('@/views/MemberAdd.vue')
const MemberIdEdit = () => import('@/views/MemberIdEdit.vue')
const AddNewMemberId = () => import('@/views/AddNewMemberId.vue')
const SearchMember = () => import('@/views/MemberSearch.vue')
const Point = () => import('@/views/Point.vue')
const PointHistory = () => import('@/views/PointHistory.vue')
const DiscountCreate = () => import('@/views/DiscountCreate.vue')
const CouponCreate = () => import('@/views/CouponCreate.vue')
// const CouponEdit = () => import('@/views/CouponEdit.vue')
const CouponList = () => import('@/views/CouponList.vue')
const CouponAcquiredList = () => import('@/views/CouponAcquiredList.vue')
const CouponActivate = () => import('@/views/CouponActivate.vue')
const CouponSearch = () => import('@/views/CouponOperation.vue')
const UserDashboard = () => import('@/views/UserDashboard.vue')
const Logout = () => import('@/views/Logout')
const Inquiry = () => import('@/views/Inquiry.vue')
const EmailTemplateList = () => import('@/views/EmailTemplateList.vue')
const EmailTemplateCategoryList = () => import('@/views/EmailTemplateCategoryList.vue')
const EmailTemplateUpload = () => import('@/views/EmailTemplateUpload.vue')
const EmailTemplateEdit = () => import('@/views/EmailTemplateEdit.vue')
const EmailSendHistory = () => import('@/views/EmailSendHistory.vue')
const EmailSettings = () => import('@/views/EmailSettings.vue')
const InquiryList = () => import('@/views/InquiryList.vue')
const CustomerInquiryList = () => import('@/views/CustomerInquiryList.vue')
const MembersCardAdd = () => import('@/views/MembersCardAdd.vue')
const MemberDiscountList = () => import('@/views/MemberDiscountList.vue')
const DiscountPlanList = () => import('@/views/DiscountPlanList.vue')
const DiscountMemberList = () => import('@/views/DiscountMemberList.vue')
const DiscountList = () => import('@/views/DiscountList.vue')

// App Pages ↓↓↓
const AppUserInfoEdit = () => import('@/views/app/UserInfo.vue')
const AppMemberRegistration = () => import('@/views/app/AppMemberRegistration.vue')
const AppUserFamily = () => import('@/views/app/UserFamily.vue')
const AppPrivacyPolicy = () => import('@/views/app/AppPrivacyPolicy.vue')
const AppUserMailUpdate = () => import('@/views/app/UserMailUpdate.vue')
const AppUserPasswordUpdate = () => import('@/views/app/UserPasswordUpdate.vue')
const AppUserDelete = () => import('@/views/app/UserWithdrawal.vue')
const NotFound = () => import('@/views/404.vue')



const ROLE = {
  ADMIN: "liberty_operator_admin",
  OPERATOR: "liberty_operator",
  MEMBER: "liberty_member",
}

Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})
// router.beforeEach((to, from, next) => {
//   // NProgress.start()
//   next()
//   alert('start')
// })
// router.afterEach(() => {
//   // NProgress.done()
//   alert('done')
// })

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/home',
      //name: 'ホーム',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'ダッシュボード',
          component: Dashboard,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: 'member-add',
          name: '新規会員登録',
          component: MemberAdd,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'profile',
          name: '会員情報',
          component: Profile,
          meta: { 
            requiresAuth: true
          }
        },
        // {
        //   path: 'App-UserMailUpdate',
        //   name: 'アプリ会員情報',
        //   component: AppUserMailUpdate,
        //   meta: { 
        //     requiresAuth: true
        //   }
        // },
        {
          path: 'discount-create',
          name: '割引プラン登録',
          component: DiscountCreate,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'coupon-create',
          name: 'クーポン登録',
          component: CouponCreate,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'coupon-list/:listTab',
          name: 'クーポン一覧',
          component: CouponList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'coupon-acquired-list/:couponId',
          name: '割引対象会員リスト',
          component: CouponAcquiredList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'coupon-activate/:userName/:couponId/:status',
          name: 'クーポン獲得',
          component: CouponActivate,
          meta: { 
            requiresAuth: true,
            // roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'user-dashboard/:userId',
          name: '会員ダッシュボード',
          component: UserDashboard,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          // path: 'profile-edit',
          path: '/profile-edit/:userId',
          name: '会員情報編集',
          component: ProfileEditPage,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: '/member-id-edit/:userId',
          name: '会員証発行',
          component: MemberIdEdit,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: '/new-member-id',
          name: '新規会員ID',
          component: AddNewMemberId,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
         {
          path: 'member-search',
          name: '会員検索',
          component: SearchMember,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'pointhistory',
          name: 'ポイント更新履歴',
          component: PointHistory,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: '/point/:userId',
          name: 'ポイント更新',
          component: Point,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'email-template-list',
          name: '配信テンプレート',
          component: EmailTemplateList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN]
          }
        }, 

        {
          path: 'email-template-page',
          name: '配信テンプレート作成',
          component: EmailTemplateUpload,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN]
          }
        },
        {
          path: 'email-template-category-list',
          name: 'カテゴリ一覧',
          component: EmailTemplateCategoryList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN]
          }
        },
        {
          path: 'email-template-edit',
          name: 'テンプレート編集',
          component: EmailTemplateEdit,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN]
          }
        }, 
        {
          path: 'email-send-history',
          name: '配達履歴',
          component: EmailSendHistory,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN]
          }
        },
        {
          path: 'email-settings',
          name: 'Eメール設定',
          component: EmailSettings,
          meta: { 
            requiresAuth: true
          }
        }, 
        {
          path: 'discount-list',
          name: '割引一覧',
          component: DiscountList,
          meta: { 
            requiresAuth: true
          }
        }, 
        {
          path: 'discount-plan-list',
          name: '割引プラン一覧',
          component: DiscountPlanList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'discount-member-list/:uuid',
          name: '割引プラン会員一覧',
          component: DiscountMemberList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'member-discount-list/:uuid',
          name: '会員割引一覧',
          component: MemberDiscountList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }, 
        {
          path: 'inquiry',
          name: 'お問合せ',
          component: Inquiry,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: 'inquirylist',
          name: 'お問合せ一覧',
          component: InquiryList,
          meta: { 
            requiresAuth: true
          }
        },
        {
          path: 'customerinquirylist',
          name: '顧客問合せ一覧',
          component: CustomerInquiryList,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'members-card-add',
          name: '会員シート打込み',
          component: MembersCardAdd,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        },
        {
          path: 'coupon-operation',
          name: 'クーポン操作',
          component: CouponSearch,
          meta: { 
            requiresAuth: true,
            roles: [ROLE.ADMIN, ROLE.OPERATOR]
          }
        }
      ]
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/add-email',
      name: 'メール追加',
      component: AddEmail
    },
    {
      path: '/app-member-registration',
      name: 'アプリ会員登録',
      component: AppMemberRegistration,
    }, 
    {
      path: '/app-UserFamily',
      name: 'アプリ会員家族',
      component: AppUserFamily,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/App-UserEdit',
      name: 'アプリ会員情報編集',
      component: AppUserInfoEdit,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/App-UserDel',
      name: 'アプリ会員情報更新',
      component: AppUserInfoEdit,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/App-UserMailUpdate',
      name: 'アプリメール更新',
      component: AppUserMailUpdate,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/App-UserPasswordUpdate',
      name: 'アプリパスワード更新',
      component: AppUserPasswordUpdate,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/App-UserDelete',
      name: 'アプリ会員退会',
      component: AppUserDelete,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/app-privacy-policy',
      name: 'AppPrivacyPolicy',
      component: AppPrivacyPolicy
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      component: About,
      meta: {
        requiresAuth: true,
        roles: [ROLE.ADMIN, ROLE.OPERATOR]
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '*',
      name: 'Not Found',
      component: NotFound
    }
  ]
}

router.beforeEach((to, from, next) => {

  let canAccessRole = true;
  
  if(router.app.$keycloak.realmAccess !== null){
    const roles = router.app.$keycloak.realmAccess.roles;

    // ログインしたロールがどれか判断
    let loginRole = ROLE.MEMBER;
    loginRole = roles.find(a => a === ROLE.OPERATOR) || loginRole;
    loginRole = roles.find(a => a === ROLE.ADMIN) || loginRole;

    // console.log("loginRole: " + loginRole)
  
    const arrowRoles = to.meta.roles;
    // console.log("arrowRoles: ")
    // console.log(arrowRoles)

    if (!arrowRoles || arrowRoles.length === 0) {
      // アクセス許可不要はアクセス可
      canAccessRole = true;
    } else {
      // 適切なロールがあればアクセス許可
      canAccessRole = arrowRoles.includes(loginRole);
    }
  }

  // console.log("authenticated: " + router.app.$keycloak.authenticated)
  // console.log("canAccessRole: " + canAccessRole)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 「認証済み＆適切なロール」のみアクセス許可
    if (router.app.$keycloak.authenticated && canAccessRole) {
      next()
    } else if (!canAccessRole) {
      // 不正アクセスはHOMEに遷移させる
      const loginUrl = router.app.$keycloak.createLoginUrl({redirectUri: window.location.protocol + "//" + window.location.host})
      window.location.replace(loginUrl)
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl({redirectUri: window.location.protocol + "//" + window.location.host + to.fullPath})
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})

export default router
